import { useWorkspaceAsset } from "@gripp/shared-logic";
import { LoadingIndicator, RoutineButtons, RoutineExecutionProps, SlideAction, Spacing, useSlideLayoutSafe } from "@gripp/shared-ui";
import { ScrollView, StyleSheet } from "react-native";
import { useLocation, useNavigate } from "react-router";
import { RoutineSubmitSource } from '../assetUtils';

export const RoutineAllColumn = ({
  assetId,
  routineId
}: {
  assetId: string,
  routineId?: string
}) => {
  // Placeholder value. 'showAll' will override this
  const initialRoutinesToShow = 50; 
    
  const navigate = useNavigate(); 
  const location = useLocation();
  const slideLayoutContext = useSlideLayoutSafe();
  const { workspaceAsset, isLoading } = useWorkspaceAsset(assetId);
  
  const onRoutineSelected = async (routine: RoutineExecutionProps) => {
    if (
      slideLayoutContext &&
      !location.state?.from?.includes(RoutineSubmitSource.RoutinesList) &&
      !location.pathname.includes('/routines/edit')
    ) {
      await slideLayoutContext.onSlideChange(SlideAction.NEXT);
    }

    navigate(
      `/assets/${assetId}/routines/${routine.routine?.id}`,
      { state: { from: RoutineSubmitSource.RoutinesList } }
    );
  };

  if (isLoading) {
    return (
      <LoadingIndicator />
    )
  }

  if (!assetId || !workspaceAsset) {
    return null;
  }

  return (
    <ScrollView style={styles.routineButtonContainer}>
      <RoutineButtons
        workspaceAsset={workspaceAsset}
        showAll
        initialRoutinesToShow={initialRoutinesToShow}
        onRoutineSelected={onRoutineSelected}
        selectedRoutineId={routineId}
        onNavigateToRoutineEdit={() => navigate(`/assets/${assetId}/routines/edit`)}
      />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  routineButtonContainer: {
    padding: Spacing.basePadding.paddingHorizontal,
    flex: 1
  }
})